import {
    SUPPORT_REFER,
    SUPPORT_REFER_HELP_DESK,
} from "../../../../errors/errorMessages"
import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { patchClientProtected } from "../../clients/clients"
import { RESTORE_USER_PERMISSIONS_AFTER_MFA } from "../../urls/private"

type IRestoreUserPermissions = {
    restoreUserPermissions: () => Promise<string | void>
}

/**
 * This hook exposes a function for restoring user permissions after MFA
 * @returns {IRestoreUserPermissions} - restoreUserPermissions function
 */
const useRestorePermissions = (): IRestoreUserPermissions => {
    const restoreUserPermissions = async (): Promise<string | void> => {
        try {
            await patchClientProtected(
                RESTORE_USER_PERMISSIONS_AFTER_MFA(),
                null
            )
            return "Permissions restored successfully."
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            let errorMsg
            if (errorObj?.code === 403) {
                errorMsg = `${errorObj?.message}. Please ${SUPPORT_REFER_HELP_DESK}`
            } else {
                errorMsg = `Unable to restore permissions. Please try again. ${SUPPORT_REFER}`
            }

            return errorMsg
        }
    }

    return {
        restoreUserPermissions,
    }
}

export default useRestorePermissions
